





























import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { defineComponent, ref, computed } from '@nuxtjs/composition-api'
import { Ref } from '@vue/composition-api'
import { useClassifiedForm } from '~/compositions/form'
import { formFieldProps } from '~/constants/form'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'
import { useNamespacedStore } from '~/compositions/store'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import { defineComponentTranslations } from '~/utils/i18n'
import CInfoModal from '~/components/shared/configurable/info/CInfoModal.vue'

export default defineComponent({
  components: { CInfoModal, FieldError },
  props: formFieldProps,
  setup(props) {
    const value = ref(false)
    const { name } = props
    const { getters: userGetters } = useNamespacedStore<UserState>(USER_NS)
    const isSingleOrAnon = computed(() => userGetters('isSingleOrAnon'))

    const onValue = (v: Ref<any>) => {
      value.value = v.value
    }

    const { valueChanged, error } = useClassifiedForm(props, { onValue })

    const handleCheckboxChange = (onlyTrades: boolean) => {
      valueChanged(name, onlyTrades)
      error.value = null
    }

    return {
      value,
      handleCheckboxChange,
      info: faInfoCircle,
      error,
      isSingleOrAnon
    }
  },
  i18n: defineComponentTranslations({
    only_trades_explanation: {
      en:
        '<ul><li>When you select "Only for trade" your classified <u>will not appear</u> in the results of <u><b>sales</b></u>, instead it will appear only in <u><b>trades</b></u>.</li><li>You can deselect it at any time, and it will appear both in sales and in trades.</li><li>Attention, "promoted classifieds" and "renewals" do not refer to trades.</li></ul>',
      el:
        '<ul><li>Επιλέγοντας "Μόνο για ανταλλαγή" η αγγελία σου <u>δεν θα εμφανίζεται</u> στα αποτελέσματα <u><b>πωλήσεων</b></u>, αλλά μόνο στις <u><b>ανταλλαγές</b></u>.</li><li>Μπορείς οποιαδήποτε στιγμή να το αποεπιλέξεις και να εμφανίζεται τόσο στις πωλήσεις όσο και στις ανταλλαγές.</li><li>Προσοχή, οι "προωθήσεις αγγελιών" και οι "ανανεώσεις" δεν αφορούν ανταλλαγές.</li></ul>'
    }
  })
})
